export const EMPTY_TITLE = 'Sans titre';
export const END_EDITION_TEXT = "Terminer l'édition";
export const CREATED_AT = 'Créé le';
export const UPDATED_AT = 'Modifié le';
export const PUSH_LABEL = 'Push(s) effectué(s) :';
